// import { create } from 'zustand'

// const CategoryListStore = create((set) => ({
//   category: '',
//   setCategory: (selectedCategory) => {
//     set({ category: selectedCategory }),
//     console.log('Category changed:', selectedCategory);
//   },
//   removeCategory: () => set({ category: '' }),
// }))

// export default CategoryListStore;

// CategoryListStore.js
import { create } from "zustand";
import { persist } from "zustand/middleware";

const CategoryListStore = create(
  persist(
    (set) => ({
      categoryList: {
        component: "",
        equipment: "",
        installer: "",
        material: "",
        panel: "",
        seller: "",
        software: "",
      },
      setCategoryList: (selectedCategoryList) => {
        // console.log('Received data in setCategoryList:', selectedCategoryList);

        if (
          selectedCategoryList &&
          typeof selectedCategoryList === "object" &&
          !Array.isArray(selectedCategoryList)
        ) {
          set({ categoryList: selectedCategoryList });
          // console.log('Successfully set category list to:', selectedCategoryList);
        } else {
          console.error(
            "Invalid category list format. Expected object, received:",
            selectedCategoryList
          );
        }
      },
      removeCategoryList: () =>
        set({
          categoryList: {
            component: "",
            equipment: "",
            installer: "",
            material: "",
            panel: "",
            seller: "",
            software: "",
          },
        }),
    }),
    {
      name: "categoryList-storage",
      getStorage: () => localStorage,
    }
  )
);

export default CategoryListStore;
